import { Pipe, PipeTransform, Injector } from '@angular/core';
import {TaxIdPipe} from "./tax-id.pipe";

@Pipe({
	name: 'dynamicPipe'
})
export class DynamicPipe implements PipeTransform {
	constructor(private readonly injector: Injector) {}
	/**
	 * This method is used to get the pipe type by name.
	 * @param pipeName The name of the pipe.
	 * @returns The pipe type.
	 */


	/**
	 * Mapping of pipe names to their respective pipe classes.
	 *
	 * ⚠️ To use a pipe with the DynamicPipe, make sure the following requirements are met:
	 * 1. The pipe must be listed in this `pipeMap` with a unique key.
	 * 2. The pipe class must be decorated with `@Injectable({ providedIn: 'root' })` to support dynamic injection.
	 * 3. The pipe must be properly imported in this file.
	 *
	 * Otherwise, Angular will throw: `NullInjectorError: No provider for PipeName!`
	 */
	private getPipeTypeByName(pipeName: string): any {
		const pipeMap: { [key: string]: any } = {
			taxId: TaxIdPipe,
		};

		const pipeType = pipeMap[pipeName];
		if (!pipeType) {
			throw new Error(`Pipe "${pipeName}" not found.`);
		}
		return pipeType;
	}
	transform(value: any, pipeName: string, ...args: any[]): any {
		if (!pipeName) {
			return value;
		}

		const pipeType = this.getPipeTypeByName(pipeName);
		const pipe = this.injector.get<typeof pipeType>(pipeType);
		return pipe.transform(value, ...args);
	}
}